var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowPassWord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 6.75C20.55 7.15 20.75 7.35 20.75 7.75C20.75 8.15 20.55 8.25 20.25 8.75C18.85 10.65 15.35 14.75 10.75 14.75C6.05 14.75 2.55 10.65 1.25 8.75C0.95 8.35 0.75 8.15 0.75 7.75C0.75 7.35 0.95 7.25 1.25 6.75C2.65 4.85 6.15 0.75 10.75 0.75C15.35 0.75 18.85 4.85 20.25 6.75Z",
    stroke: "#AEB6FB",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 7.75C13.75 6.05 12.45 4.75 10.75 4.75C9.05 4.75 7.75 6.05 7.75 7.75C7.75 9.45 9.05 10.75 10.75 10.75C12.45 10.75 13.75 9.45 13.75 7.75Z",
    stroke: "#AEB6FB",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPassWord);
export default __webpack_public_path__ + "static/media/showPassWord.8bee231f8f575e3e5a18d855ee68fd2e.svg";
export { ForwardRef as ReactComponent };